import { Card, Text } from "@mantine/core";

interface Props {
  label: string;
  value: string | null;
  /** True while refetching: hold the previous value rather than flashing. */
  isRefreshing?: boolean;
}

/**
 * One raw string value, shown verbatim as "label: value" — no aggregation,
 * no numeric formatting. Pairs with config.TextTile / AggregateResult's
 * kind === "text", for a value that is already the thing to show (a
 * pipeline-formatted timestamp, a run label).
 *
 * Deliberately smaller and single-line, unlike StatTile's two-line number
 * display: the value here is text of unknown length, not a figure meant to
 * read at a glance from across the room.
 */
export function TextTile({ label, value, isRefreshing = false }: Props) {
  return (
    <Card
      withBorder
      padding="sm"
      style={{
        display: "inline-block",
        opacity: isRefreshing ? 0.55 : 1,
        transition: "opacity 150ms ease",
      }}
    >
      <Text size="sm">
        <Text span c="dimmed">
          {label}:{" "}
        </Text>
        <Text span fw={500}>
          {value ?? "—"}
        </Text>
      </Text>
    </Card>
  );
}
